exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_Divider_2sP0BRXL5YhrP8-60LyJTR {\n\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.IA_DividerHR_3GCFaTZW8TpQJ5hP3Q1W1W {\n  height: 0;\n}", ""]);

// Exports
exports.locals = {
	"IA_Divider": "IA_Divider_2sP0BRXL5YhrP8-60LyJTR",
	"IA_DividerHR": "IA_DividerHR_3GCFaTZW8TpQJ5hP3Q1W1W"
};